import { configureStore } from "@reduxjs/toolkit";
import * as Sentry from "@sentry/react";
import { ProcessMiddleware } from "redux-process";

import APIResponse from "../middleware/APIResponse";
import APIService from "../middleware/APIService";
import apiWarnings from "../middleware/ApiWarnings";
import ErrorResponse from "../middleware/ErrorResponse";
import RequestTracker from "../middleware/RequestTracker";
// import processes
import processes from "../processes";
import rpOptions from "../processes/options";
import request from "../processes/request";
// reducers
import rootReducer from "../reducers";

export default function initializeStore(data) {
	const sentryReduxEnhancer = Sentry.createReduxEnhancer({
		attachReduxState: false,
	});

	const store = configureStore({
		reducer: rootReducer,
		preloadedState: data,
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware({
				serializableCheck: false,
				immutableCheck: false,
			}).concat([
				ProcessMiddleware(processes, request, rpOptions),
				APIService,
				APIResponse,
				ErrorResponse,
				apiWarnings,
				RequestTracker,
			]),
		enhancers: [sentryReduxEnhancer],
	});

	return store;
}
